interface Props {
  type: {
    title: string;
    option: string;
    guidance: string;
  };
}

export default function ResultsType(prop: Props): string | any {
  return (
    <div className="rai-assessment__results-summary-tip-results">
      <h4 className="rai-assessment__results-summary-tip-title">
        Q: {prop.type.title}
      </h4>
      <p className="rai-assessment__results-summary-tip-answer">
        A: {prop.type.option}
      </p>
      <p className="rai-assessment__results-summary-tip-guidance">
        {prop.type.guidance}
      </p>
    </div>
  );
}
